/**
 * Minimum quantity per product (theme setting).
 */
(function () {
  const cfg = window.themeHDN?.settings?.minCartQty;
  if (!cfg?.enabled) return;

  const themeMin = Math.max(1, parseInt(cfg.quantity, 10) || 100);
  const messageTemplate =
    cfg.message || 'Minimum order quantity is {{ quantity }} items for this product.';

  const formatMessage = (min) =>
    messageTemplate.replace(/\{\{\s*quantity\s*\}\}/g, String(min));

  const isGiftWrapContext = (el) => {
    if (!el) return false;
    if (el.closest('.is-gift-wrap')) return true;
    if (cfg.giftWrapVariantId) {
      const form = el.closest('form');
      const idInput = form?.querySelector('[name="id"]');
      if (idInput && String(idInput.value) === String(cfg.giftWrapVariantId)) return true;
    }
    return false;
  };

  const getEffectiveMin = (input) => {
    if (!input) return themeMin;
    const fromData = parseInt(input.dataset.minCartQty, 10);
    if (!Number.isNaN(fromData) && fromData > 0) return fromData;
    const ruleMin = parseInt(input.getAttribute('min'), 10) || 1;
    return Math.max(ruleMin, themeMin);
  };

  const showError = (context, message) => {
    const root =
      context?.closest?.('wrapp-hdt-pr-frm, wrapp-hdt-pr-frm-bundle, tr, hdt-line-item, .hdt-cart-item') ||
      context;
    const errorEl =
      root?.querySelector?.('[ref="addToCartTextError"]') ||
      root?.querySelector?.('.hdt-quantity--error, .hdt-form-message--error');

    if (errorEl) {
      errorEl.removeAttribute('hidden');
      const msgEl = errorEl.querySelector('.hdt-error-message');
      if (msgEl) msgEl.textContent = message;
    }

    if (typeof ToastNotification !== 'undefined' && window.themeHDN?.extras?.cart) {
      ToastNotification.error(message, window.themeHDN.extras.cart.toast_title);
    }
  };

  const applyMinToInputs = (root = document) => {
    root.querySelectorAll('input[name="quantity"], input[name="updates[]"]').forEach((input) => {
      if (isGiftWrapContext(input)) return;
      const min = getEffectiveMin(input);
      input.min = String(min);
      input.dataset.minCartQty = String(min);
      if (input.name === 'updates[]') {
        input.dataset.lastValidQty = input.value;
      }
    });
  };

  const validateProductForm = (form) => {
    if (isGiftWrapContext(form)) return true;

    const bundleQtyInputs = form.querySelectorAll('input[name="items[][quantity]"]');
    if (bundleQtyInputs.length) {
      for (const item of bundleQtyInputs) {
        const qty = parseInt(item.value, 10) || 0;
        if (qty > 0 && qty < themeMin) {
          showError(form, formatMessage(themeMin));
          return false;
        }
      }
      return true;
    }

    const qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) return true;

    const qty = parseInt(qtyInput.value, 10) || 0;
    const min = getEffectiveMin(qtyInput);
    if (qty < min) {
      showError(form, formatMessage(min));
      return false;
    }
    return true;
  };

  const cartHasInvalidQty = () =>
    [...document.querySelectorAll('input[name="updates[]"]')].some((input) => {
      if (isGiftWrapContext(input)) return false;
      const min = getEffectiveMin(input);
      return (parseInt(input.value, 10) || 0) < min;
    });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('wrapp-hdt-pr-frm, wrapp-hdt-pr-frm-bundle')) return;
    if (!validateProductForm(form)) {
      event.preventDefault();
    }
  });

  const restoreCartQtyInput = (input) => {
    const min = getEffectiveMin(input);
    const lastValid = parseInt(input.dataset.lastValidQty, 10);
    const restore = !Number.isNaN(lastValid) && lastValid >= min ? lastValid : min;
    input.value = String(restore);
    return restore;
  };

  const validateQtyInput = (input, { silent = false } = {}) => {
    if (!input || isGiftWrapContext(input)) return true;

    const min = getEffectiveMin(input);
    const qty = parseInt(input.value, 10) || 0;
    if (qty > 0 && qty < min) {
      if (input.name === 'updates[]') {
        restoreCartQtyInput(input);
      } else {
        input.value = String(min);
      }
      if (!silent) showError(input, formatMessage(min));
      return false;
    }
    if (input.name === 'updates[]') {
      input.dataset.lastValidQty = String(qty);
    }
    return true;
  };

  document.addEventListener(
    'focusin',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'updates[]') return;
      if (isGiftWrapContext(input)) return;
      input.dataset.lastValidQty = input.value;
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (input.name !== 'updates[]' && input.name !== 'quantity') return;
      validateQtyInput(input);
    },
    true
  );

  document.addEventListener(
    'quantity-selector:update',
    (event) => {
      const { quantity, line } = event.detail || {};
      if (!line) return;

      const input = document.querySelector(`input[name="updates[]"][data-index="${line}"]`);
      if (!input || isGiftWrapContext(input)) return;
      if (quantity === 0) return;

      const min = getEffectiveMin(input);
      if (quantity > 0 && quantity < min) {
        event.stopImmediatePropagation();
        event.preventDefault();
        restoreCartQtyInput(input);
        showError(input, formatMessage(min));
      }
    },
    true
  );

  document.addEventListener('variant:update', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    const sectionId = event.detail?.sectionId;
    const input =
      (sectionId && document.querySelector(`#Quantity-${sectionId}`)) ||
      document.querySelector('.hdt-quantity__input[name="quantity"]');
    if (!input || isGiftWrapContext(input)) return;

    const ruleMin = variant.quantity_rule?.min || 1;
    const effective = Math.max(ruleMin, themeMin);
    input.min = String(effective);
    input.dataset.minCartQty = String(effective);
    if ((parseInt(input.value, 10) || 0) < effective) {
      input.value = String(effective);
    }
  });

  document.addEventListener('click', (event) => {
    const checkoutBtn = event.target.closest('[data-cart-checkout]');
    if (!checkoutBtn) return;
    if (!cartHasInvalidQty()) return;
    event.preventDefault();
    const firstInvalid = [...document.querySelectorAll('input[name="updates[]"]')].find((input) => {
      if (isGiftWrapContext(input)) return false;
      return (parseInt(input.value, 10) || 0) < getEffectiveMin(input);
    });
    if (firstInvalid) {
      showError(firstInvalid, formatMessage(getEffectiveMin(firstInvalid)));
    }
  });

  applyMinToInputs();
  document.addEventListener('shopify:section:load', (e) => applyMinToInputs(e.target));
  document.addEventListener('cart:drawer:render', () => applyMinToInputs());
  document.addEventListener('cart:main:render', () => applyMinToInputs());
})();
